<template>
  <div class="row">
    <div v-if="chartHasNoData" class="chart-has-no-data">
      <img src="static/img/no_data.svg" style="">
      <!-- <b-notification type="is-custom" :active.sync="chartHasNoData">
        <strong>Info! &nbsp;</strong> No data available
      </b-notification> -->
    </div>
    <div v-else class="chart-wrapper">
      <!-- <div class="chart-title">
        <div class="columns bg-primary">
          <div class="hidden">
              {{sourceClicked}} {{stateSelected}}
          </div>
        </div>
      </div> -->
      <div class="chart-stage">
        <highcharts :options="highchart_options" ref="highcharts"></highcharts>
      </div>
    </div>
  </div>
</template>

<script>
import Fullscreen from "vue-fullscreen/src/component.vue"
import MultiSelect from 'vue-multiselect'
import vueSlider from 'vue-slider-component';
import { Carousel3d, Slide } from 'vue-carousel-3d';
import { mapGetters } from 'vuex';
import str_limit from '@/assets/js-on/strlimit';

import { mapMutations } from 'vuex'

export default {
    name: 'slide5sub1',
    components: {Fullscreen, Carousel3d, Slide, MultiSelect, vueSlider},
    props: ['relativeIndicator','selectedIndicator','sourceClicked','appData','selectedState','chartType','indicatorClicked'],
    data () {
        return {
            chartHasNoData: false,
            fullscreen: false,
            lsData: JSON.parse(this.$ls.get('car_other_dataset')),
            isDataLoadedFirstTime: false,
            colors: ['#2f7ed8', '#0d233a', '#8bbc21', '#910000', '#1aadce',
            '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'],
            searchTerm: '',
            traceArray: [],
            // selectedIndicator: 'Skilled attendance at delivery or birth',
            optionsIndicator: [],
            optionSources: [],
            dataSources: ['MICS', 'NHMIS', 'NNHS', 'NDHS', 'NMIS', 'NARHS', 'IHME', 'World Bank', 'WHO-GHO', 'WUENIC'],
            // selectedState: 'National',
            // optionStates: ["Abia", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Benue", "Borno", "Bayelsa",
            //     "Cross River", "Delta", "Ebonyi", "Edo", "Ekiti", "Enugu", "FCT", "Gombe", "Imo",
            //     "Jigawa", "Kaduna", "Kebbi", "Kano", "Katsina", "Kogi",  "Kwara", "Lagos", "Nasarawa", "National",
            //     "Niger", "Ogun", "Ondo", "Osun", "Oyo", "Plateau", "Rivers", "Sokoto", "Taraba", "Yobe",
            //     "Zamfara"],
            selectedSource: '',
            headerObj: {},
            data: [],
            tableColumnHeaderAttr: null,
            highchart_options:{
                chart: {
                    type: 'line',
                    // spline, inverted: true,
                    height: 440,
                    zoomType: 'xy'
                },
                title: {
                    text: 'Loading...',
                    style: {
                        fontSize: '16px',
                        fontFamily: '"Open Sans", sans-serif',
                        fontWeight: '600'
                    }
                },

                subtitle: {
                    text: "Loading...",
                    style: {
                        fontSize: '11px',
                        fontFamily: '"Open Sans", sans-serif',
                        fontWeight: 'normal'
                    }
                },
                credits: {
                  enabled: false
                },
                xAxis: {
                    // reversed: true,
                    type: 'category',
                    categories: null,
                    title: {
                      enabled: false,
                      text: 'x-axis title'
                    },
                    labels: {
                      style: {
                        fontWeight: 'normal',
                        color: '#686464'
                      }
                    },
                    tickInterval: 4,
                    // maxPadding: 0.05,
                    showLastLabel: true
                },
                yAxis: {
                  gridLineWidth: 0,
                  minorGridLineWidth: 0,
                  min: 0,
                  title: {
                      text: ''
                  },
                  //minRange: 100,
                  // tickInterval: 20,
                },
                legend: {
                  enabled: true,
                  // backgroundColor: '#FCFFC5',
                  // borderColor: 'black',
                  // borderRadius: 10,
                  // borderWidth: 3,
                  verticalAlign: 'top',
                  x: -20,
                  y: -5,
                  title: {
                    // text: 'City<br/><span style="font-size: 9px; color: #666; font-weight: normal">(Click to hide)</span>',
                    // style: {
                    //   fontWeight: 'normal'
                    // }
                  },
                  itemStyle: {
                    fontWeight: 'normal',
                    fontSize: '13px'
                  }
                  // layout: 'vertical',
                  // align: 'right',
                  // floating: false,
                  // borderWidth: 1,
                  // shadow: true
                },
                plotOptions: {

                  series: {
                      connectNulls:true,
                      borderWidth: 0,
                      dataLabels: {
                        enabled: false,
                        format: '{point.y:.1f}%',
                        style: {
                          fontWeight: 'normal'
                        }
                      },
                      cursor: 'pointer',
                      dashStyle: "Solid",
                      point: {
                      },
                      marker: {
                        lineWidth: 0,
                        radius: 3,
                        symbol: 'circle'
                      },
                      connectNulls: true
                      // zones: []
                  },
                  colorByPoint: true

                },
                tooltip: {
                    // backgroundColor: '#FCFFC5',
                    // borderColor: 'black',
                    // borderRadius: 10,
                    // borderWidth: 3,
                    // crosshairs: [true, true],
                    headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                    pointFormat: '<span style="color:{point.color}">{point.x}</span>: <b>{point.y:.2f}%</b> of total<br/>'
                },
                series: [
                  {
                    name: 'example',
                    data: []
                  }
                ], //this.lineChartData
                exporting: {
                    buttons: {
                        contextButton: {
                            menuItems: [
                      "printChart",
                      "separator",
                      "downloadPNG",
                      "downloadJPEG",
                      "downloadPDF",
                      "downloadSVG",
                      "separator",
                      "downloadCSV",
                      "downloadXLS",
                      //"viewData",
                      "openInCloud"
                    ],
                            symbol: 'download',
                            // symbolStrokeWidth: 2,
                            // symbolFill: '#330033',
                            // symbolStroke: '#b3d4fc'
                        }
                    }
                }
            },
        }
    },
    methods: {
        toggle () {
            // this.$refs['fullscreen'].background = "green";
            this.$refs['fullscreen'].toggle();
        },
        enter(){
            return true
        },
        //  ...mapMutations([
        //     'storeHeaderIndex', // map `this.increment()` to `this.$store.commit('increment')`

        //     // `mapMutations` also supports payloads:
        //     'incrementBy' // map `this.incrementBy(amount)` to `this.$store.commit('incrementBy', amount)`
        // ]),
        getCurrentSourceOptions(indicator) {
            let sources = [];
            var statesByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
            for(var k in this.dataSources){
              for(var i in statesByIndicatorByYear){
                for(var j in statesByIndicatorByYear[i]){
                    let indicatorSource = indicator + ' -> ' + this.dataSources[k];
                    let indicatorSourceIndex = this.lsData[0].indexOf(indicatorSource)-1;
                    if(statesByIndicatorByYear[i][j][indicatorSourceIndex] !== "" && indicatorSourceIndex>0){
                      if(sources.indexOf(this.dataSources[k])<0)
                        sources.push(this.dataSources[k]);
                      break;
                    }
                }
              }
            }
            this.optionSources = sources;
        },
        plotStateChart() {
            this.data = [];
            var statesByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
            var selectedStateByIndicatorByYear = statesByIndicatorByYear[this.selectedState];

            var data_trace = [];
            this.highchart_options.series = [];
            this.highchart_options.title.text = this.selectedIndicator;
            this.highchart_options.subtitle.text = this.lineChartData[2]+' - ' + this.selectedState;;
            this.highchart_options.tooltip.headerFormat ='<span style="font-size:11px"><b>{point.key}</b></span><br>';
            this.highchart_options.tooltip.pointFormat = '<span style="color:{point.color}"><b>{series.name}</b></span>: <b>{point.y:.2f}</b><br/>'

            if(Array.isArray(this.dataSources) && this.dataSources.length > 1){
                this.multipleSourcesClicked(this.dataSources);
            } else if (Array.isArray(this.dataSources) && this.dataSources.length < 2) {
                this.singleSourceClicked(this.selectedIndicator,this.dataSources[0])
            } else {
                this.singleSourceClicked(this.selectedIndicator,this.dataSources)
            }
        },
        //Method for plotting line chart if sources selected are more than one
        multipleSourcesClicked(sources){
            var statesByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
            var selectedStateByIndicatorByYear = statesByIndicatorByYear[this.selectedState];
            sources.map( (elem, index) => {
                var indicatorSource = this.selectedIndicator + ' -> ' + elem;

                if (this.lsData[0].indexOf(indicatorSource) > 0) {
                    var indexOfindicatorSource = this.lsData[0].indexOf(indicatorSource) - 1;
                    var sourceStateYearsVals = selectedStateByIndicatorByYear.map( (elem2, index2) => {
                        return [elem2[0], elem2[indexOfindicatorSource] ];
                    });
                    var xAxis = [], yAxis = [];
                    sourceStateYearsVals.map( (elem3, index3) => {
                        xAxis.push(elem3[0]);
                        yAxis.push(elem3[1]);
                    });
                    // var trace = {
                    //     x: xAxis,
                    //     y: yAxis,
                    //     type: 'line',
                    //     name: elem,
                    //     // fill: 'toself',
                    //     line: {'shape': 'spline', 'smoothing': 1.0,
                    //             dash: 'dot'},
                    //     connectgaps: true,
                    //     // text: yAxis,
                    //     // hoverinfo: 'none',
                    //     textposition: 'bottom right',
                    //     mode: 'lines+markers',
                    //     marker: {
                    //         size: 10
                    //     }
                    //     // mode: 'lines+markers'
                    // }

                    var series_data = {name: elem, data: yAxis}
                    this.highchart_options.xAxis.categories = xAxis
                    this.highchart_options.series.push(series_data)
                    // this.checkPlotMaxRange(yAxis);
                    // data_trace.push(trace);
                }
            });
        },
        //Method to execute when a single source is selected
        singleSourceClicked(indicator,elem){
            this.highchart_options.series = [];
            //elem is the selected source
            var statesByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
            var selectedStateByIndicatorByYear = statesByIndicatorByYear[this.selectedState];
            var indicatorSource = indicator + ' -> ' + elem;
            if (this.lsData[0].indexOf(indicatorSource) > 0) {
                var indexOfindicatorSource = this.lsData[0].indexOf(indicatorSource) - 1;
                var sourceStateYearsVals = selectedStateByIndicatorByYear.map( (elem2, index2) => {
                    return [elem2[0], elem2[indexOfindicatorSource] ];
                });
                this.chartHasNoData = true;
                var xAxis = [], yAxis = [];
                sourceStateYearsVals.map( (elem3, index3) => {
                    if(elem3[1] !== ""){
                        yAxis.push(elem3);
                        this.chartHasNoData = false;
                    }
                });
                // To check if a single value exists in the yAxis array
                let color = this.colors[Math.floor(Math.random() * 10)];
                // console.log(color);
                
                //Dynamically calculate the tick interval based on the difference between the highest and lowest year

                if(yAxis[yAxis.length-1][0] - yAxis[0][0]  < 8){
                    this.highchart_options.xAxis.tickInterval = 1;
                } else if(yAxis[yAxis.length-1][0] - yAxis[0][0] < 16){
                    this.highchart_options.xAxis.tickInterval = 2;
                } else if(yAxis[yAxis.length-1][0] - yAxis[0][0] < 24){
                    this.highchart_options.xAxis.tickInterval = 4;
                } else {
                    this.highchart_options.xAxis.tickInterval = 8;
                }
                var series_data = {
                    name: elem,
                    data: yAxis,
                    color: color
                }
                this.highchart_options.series.push(series_data)
                // this.checkPlotMaxRange(yAxis);
                // data_trace.push(trace);
            }
        },
        checkPlotMaxRange(yAxis) {
            var maxValForRangeSup = Math.max.apply(null, yAxis);
            if (maxValForRangeSup > 100) {
                this.layout.yaxis.range = [0, maxValForRangeSup % 10 === 0? maxValForRangeSup: maxValForRangeSup + maxValForRangeSup % 10 ];
                this.layout.yaxis.dtick = (maxValForRangeSup + maxValForRangeSup % 10) / 5;
            }else{
                this.layout.yaxis.range = [0, 100 ];
                this.layout.yaxis.dtick = 25;
            }
        },
        //Plot chart for single selected source and indicator
        plotSourceChart(indicator,source){
            this.data = [];
            var statesByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
            var selectedStateByIndicatorByYear = statesByIndicatorByYear[this.selectedState];
            this.highchart_options.exporting.filename = indicator +" ("+ source + ")";
            var data_trace = [];
            this.highchart_options.series = [];
            this.highchart_options.title.text = indicator;
            this.highchart_options.subtitle.text = source+' - ' + this.selectedState;
            this.highchart_options.tooltip.headerFormat ='<span style="font-size:11px"><b>{point.key}</b></span><br>';
            this.highchart_options.tooltip.pointFormat = '<span style="color:{point.color}"><b>{series.name}</b></span>: <b>{point.y:.2f}</b><br/>';
            this.singleSourceClicked(indicator,source);
        },
        sourceAndYearComputation(indicator){
            this.getCurrentSourceOptions(indicator);
            let randomSource = Math.floor(Math.random() * this.optionSources.length);
            this.selectedSource = this.sourceClicked;
        },
        // A method that calculates the width of the bars if the chart type is a bar and sets highchart pointWidth option
        calculatePointWidth(val){
            if(val === 'column'){
                // let yAxis = this.highchart_options.series[0].data;
                    this.highchart_options.plotOptions.series.pointWidth = 8;
                // //Dynamically calculate the tick interval based on the difference between the highest and lowest year
                // if(yAxis[yAxis.length-1][0] - yAxis[0][0]  < 8){
                //     this.highchart_options.plotOptions.series.pointWidth = 8;
                // } else if(yAxis[yAxis.length-1][0] - yAxis[0][0] < 16){
                //     this.highchart_options.plotOptions.series.pointWidth = 4;
                // } else if(yAxis[yAxis.length-1][0] - yAxis[0][0] < 24){
                //     this.highchart_options.plotOptions.series.pointWidth = 2;
                // } else {
                //     this.highchart_options.plotOptions.series.pointWidth = 1;
                // }
            }
        }

    },
    computed: {
        // sourceClicked() {
        //     this.tableColumnHeaderAttr = this.$store.getters.getSourceClicked;
        //     var source = this.tableColumnHeaderAttr[0];
        //     var val = this.tableColumnHeaderAttr[1];
        //     var carSources = this.$store.getters.getCarSources;
        //     var selectedSource = [source]; // ? [source]: carSources;
        //     if (!val) {
        //         selectedSource = carSources
        //     }
        //     this.selectedSource = selectedSource;
        //     return selectedSource;
        // },
        indicatorSelected() {

            // this.selectedIndicator = this.lineChartData[1]; // this.$store.getters.getSelectedIndicator;
            var temp = this.$store.getters.getShortIndicatorNames(this.selectedIndicator);
            return str_limit(temp, 80);
        },
        // stateSelected() {
        //     this.selectedState = this.$store.getters.getSelectedState;
        //     return this.selectedState;
        // }
    },
    created() {

    },
    mounted () {
        if (this.lsData) {
            this.selectedSource = this.sourceClicked;
            if (this.selectedIndicator.length < 1) {
                if(this.selectedSource === ''){
                    this.sourceAndYearComputation(this.relativeIndicator); // Calculates the sources with data for the selected indicator
                }
                this.plotSourceChart(this.relativeIndicator,this.selectedSource); // Plots the chart
                this.highchart_options.chart.type = this.chartType; // Changes the chart type to line/bar
                this.calculatePointWidth(this.chartType); // A method call that calculates the width of the bars if the chart type is a bar
            } else {
                if (this.indicatorClicked.length > 1) {
                    if(this.selectedSource === ''){
                        this.sourceAndYearComputation(this.indicatorClicked); // Calculates the sources with data for the selected indicator
                    }
                    this.plotSourceChart(this.indicatorClicked,this.selectedSource); 
                    this.highchart_options.chart.type = this.chartType; 
                    this.calculatePointWidth(this.chartType); 
                } else {
                    if(this.selectedSource === ''){
                        this.sourceAndYearComputation(this.selectedIndicator); // Calculates the sources with data for the selected indicator
                    }
                    this.plotSourceChart(this.selectedIndicator,this.selectedSource); 
                    this.highchart_options.chart.type = this.chartType; 
                    this.calculatePointWidth(this.chartType); 
                }
            }
        }
    },
    updated(){
        // Plotly.relayout(this.$refs.others_sub1, {
        //     'xaxis.autorange': true,
        //     'yaxis.autorange': false
        // });
    },
    watch: {
        selectedIndicator(val){
           this.selectedSource = this.sourceClicked;
            this.sourceAndYearComputation(val);
            this.plotSourceChart(val,this.selectedSource);
        },
        sourceClicked(val){
            // console.log(val)
            this.selectedSource = val;
            if (this.selectedIndicator !== '') {
                this.plotSourceChart(this.selectedIndicator,val);
            } else {
                this.plotSourceChart(this.relativeIndicator,val);
            }
        },
        chartType(val){
            this.highchart_options.chart.type = val;
            this.calculatePointWidth(val);
        },
        selectedState(val){
            if (this.selectedIndicator !== '') {
                this.plotSourceChart(this.selectedIndicator,this.selectedSource);
            } else {
                this.plotSourceChart(this.relativeIndicator,this.selectedSource);
            }
        },
        indicatorClicked(val){
            this.sourceAndYearComputation(val);
            this.plotSourceChart(val,this.selectedSource);
        }
    }
}

</script>

<style scoped>
    div[class^="col"]{padding-left:7px; padding-right:7px;}
     /* Some styles live in App.vue file*/
</style>



// WEBPACK FOOTER //
// line.vue?6930f5d8